import { AfterViewInit, Component, ContentChild, ContentChildren, ElementRef, EventEmitter, HostListener, Input, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { WizardCompleteComponent, WizardFailComponent } from '../..';
import { ButtonType, WizardButtonComponent } from './wizard-button/wizard-button.component';
import { WizardStepComponent } from './wizard-step/wizard-step.component';

export type WizardStatus = 'complete' | 'fail' | 'loading' | undefined;

@Component({
  selector: 'mpro-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements AfterViewInit {
  @ContentChild(WizardCompleteComponent)
  public complete: WizardCompleteComponent;
  @ContentChild(WizardFailComponent)
  public fail: WizardFailComponent;
  @ContentChildren(WizardButtonComponent)
  public buttons: QueryList<WizardButtonComponent>;
  @ContentChildren(WizardStepComponent)
  public steps: QueryList<WizardStepComponent>;
  public currentStep: { index: number, step: WizardStepComponent | undefined } = { index: 0, step: undefined };
  @ViewChildren('stepLabelIndex')
  public stepLabelIndexes: QueryList<ElementRef>;
  @ViewChild('stepsHeader')
  public stepsHeader: ElementRef;
  @ViewChildren('stepLine')
  public stepLines: QueryList<ElementRef>;
  @HostListener('window:resize')
  public onResize() {
    this.drawLinesBetweenSteps();
  }
  @Input() public title?: string;
  @Input() public subtitle?: string;
  @Input() public status: WizardStatus = undefined;
  @Output() public onBack: EventEmitter<void> = new EventEmitter();
  @Output() public onNext: EventEmitter<void> = new EventEmitter();
  @Output() public onFinish: EventEmitter<void> = new EventEmitter();
  @Output() public onClose: EventEmitter<void> = new EventEmitter();

  constructor(private renderer: Renderer2) { }

  public ngAfterViewInit(): void {
    if (!this.currentStep.step) {
      setTimeout(() => {
        this.currentStep = {
          index: 0,
          step: this.steps.first
        }
      });
    }
    this.drawLinesBetweenSteps();
  }

  public finish(): void {
    this.onFinish.emit();
  }

  public next(): void {
    const nextStepIndex = this.currentStep.index + 1;
    const nextStep = this.steps.get(nextStepIndex);
    if (!nextStep) {
      return;
    }
    if (this.currentStep.step) {
      this.currentStep.step.status = 'completed';
    }
    this.currentStep = {
      index: nextStepIndex,
      step: nextStep
    }
    this.onNext.emit();
  }

  public back(): void {
    const prevStepIndex = this.currentStep.index - 1;
    const prevStep = this.steps.get(prevStepIndex);
    if (!prevStep) {
      return;
    }
    prevStep.status = 'inprogress';
    this.currentStep = {
      index: prevStepIndex,
      step: prevStep
    }
    this.onBack.emit();
  }

  public close(): void {
    this.onClose.emit();
  }

  public getButtonLabel(type: ButtonType): string {
    const button = this.buttons.find(button => button.type === type);
    if (button && button.label) {
      return button.label;
    }

    switch (type) {
      case 'back':
        return 'Back';
      case 'next':
        return 'Next';
      case 'finish':
        return 'Finish';
      case 'close':
        return 'Close';
      default:
        return '';
    }
  }

  private drawLinesBetweenSteps(): void {
    this.stepLabelIndexes.forEach((element, index) => {
      const next = this.stepLabelIndexes.get(index + 1);
      const currentLine = this.stepLines.get(index);

      if (!next || !currentLine) {
        return;
      }

      const wrapper = this.stepsHeader.nativeElement.getBoundingClientRect();
      const current = element.nativeElement.getBoundingClientRect();
      const nextRect = next.nativeElement.getBoundingClientRect();

      this.renderer.setStyle(currentLine.nativeElement, 'top', `${current.height / 2}px`);
      this.renderer.setStyle(currentLine.nativeElement, 'left', `${current.left - wrapper.left + (current.width / 2)}px`);
      this.renderer.setStyle(currentLine.nativeElement, 'width', `${(nextRect.left - wrapper.left) - (current.left - wrapper.left)}px`);
    });
  }
}